import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from './shared/authentication.service';
import { Router } from '@angular/router';
import { User } from './shared/User';
import { DetailsSidenavService } from './services/details-sidenav.service';
import { MatDialog, MatSnackBar, MatSnackBarConfig, MatDialogConfig } from '@angular/material';
import { EditProfileComponent } from './edit-profile/edit-profile/edit-profile.component';
import { BreadcrumbService } from './site-view/breadcrumb/breadcrumb.service';
import { AlarmMessageService } from './services/alarm-message-service.service';
import { SelectedElementsService } from './services/selected-elements.service';
import { AlarmGroupService } from './services/alarm-group.service';
import { AlarmService } from './services/alarm.service';
import { AlarmMessage } from './models/alarm-message';
import { SiteService } from './services/site.service';
import { ChangePasswordComponent } from './system-management/system-users/modals/change-password/change-password.component';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  title:string = 'RSM NMS';
  user: User;
  isSideNav: boolean;

  isSearchOn:boolean = false;

  numberOfAlarmsArray:number[] = [];



  @ViewChild('rightButton', {read: ElementRef, static: false}) rightButton: ElementRef;

  constructor(public authService: AuthenticationService,
    private sideNavServ: DetailsSidenavService,
    private router: Router, private dialog: MatDialog,
    private breadcrumbService: BreadcrumbService,
    private alarmMessageService: AlarmMessageService,
    private selectedElementService:SelectedElementsService,
    private alarmGroupService: AlarmGroupService,
    private alarmService: AlarmService,
    private siteService:SiteService) {

    
  }

  
  //admin can't go to user component, so start him of at notifications... 
  routerLink(): String{
    if(this.authService.isUserMan())
      return "/management/users"
    else 
      return "/management/classifications"
  }

  //user man ca't see dashboard
  isSystemManagmentDisabled(): boolean{
    if(this.authService.isUserMan || this.authService.isAdmin)
      return false;
    else
      return true;
  }

  resetBreadcrumbs(){
    this.breadcrumbService.crumbs = [{key: -1, value: 'RSM'}] // incorporate this with session storage, to fix reload/forward/back navigation kind
  }

  initNumberOfAlarms(event: Event){
    this.numberOfAlarmsArray = [];
    console.log('init number of alarms',
    this.alarmMessageService.alarmMessages)

    this.alarmMessageService.alarmMessages = []

    //go into alarms and remove
    
  }

  ngOnInit() {
    this.user = this.authService.USER;
    this.alarmMessageService.changeSubject.subscribe(item => this.numberOfAlarmsArray.push(item))
  }


  goToSite(alarmMessage: AlarmMessage): void {

    this.alarmService.getAlarmByAlarmId(alarmMessage.alarm.alarm_id)
    .pipe(take(1))
    .subscribe( alarmArr => {

      var siteId:number;
      
     

      //have service always send siteid at a consistent place... 
      try {
        if(alarmArr[0].site)
        siteId = alarmArr[0].site_id
      } catch (error) {
        if (alarmArr[0].device)
        siteId = alarmArr[0].device.site_id
      }

      this.router.navigate([`/site/detail/${siteId}/alarm-overview`]);
      this.siteService.getSiteById(siteId).subscribe(res=>{
        this.selectedElementService.siteIdChangeSubject.next(res[0]);
      }) //notify whoever is listening that this value has changed
      
      
      this.breadcrumbService.crumbs.pop(); //if site is in different region, this won't work
      this.breadcrumbService.subject.next({key:siteId, value: alarmMessage.alarm.site.name});
  
  
      this.selectedElementService.selectedSiteId = siteId;
  
      //localStorage.setItem("ACTIVESITE", JSON.stringify(site.site_id));
  
      //clear on site component destroy
      localStorage.setItem("ACTIVESITE", JSON.stringify(siteId));
      
  
      this.initSiteData(siteId)
  
      //this.alarmMessageService.alarmMessages()
  
      console.log("alarm message ", alarmMessage )

    })

  }


  initSiteData(siteId: number){
    this.alarmGroupService.getAlarmGroupCount(siteId);
    this.alarmService.getAlarmsBySite(siteId);
  }


  toggleSideNav() {


    if(this.sideNavServ.getRegionSideNav().opened){
      this.sideNavServ.closeRegSideNav();
    } else if(!this.sideNavServ.getRegionSideNav().opened){
      this.sideNavServ.openRegSideNav();
    }

  }


  openEditDialog(){
    const conf = {
      data:{
        currentUser:this.authService.USER
      },
      width:'350px',

      panelClass:'app-full-bleed-dialog'
    }

    this.dialog.open(EditProfileComponent, conf)
  }

  openEditPasswordDialog(user:any){
    const conf = {
      data:{
        currentUserUsername: this.user.name
      },
     
      panelClass:'app-full-bleed-dialog',
      
    }
    this.dialog.open(ChangePasswordComponent, conf);
  }


  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
    // this.alarmMessageService.unsubscribeStompCient()
  }

}

//{panelClass:'red',horizontalPosition:'right', verticalPosition:'top'}